@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.gsb.vyapar.bhagya.util

expect object BuildConfig {
    fun isDebug(): Boolean

    fun platform(): PlatformType

    fun getVersion(): String

    fun userAgent(): PlatformType
}

sealed class PlatformType {
    data object ANDROID : PlatformType()
    data object IOS : PlatformType()
    data object DESKTOP : PlatformType()
    data object JS : PlatformType()
    data object WASM : PlatformType()
}

fun String.value(): String {
    val value = StringBuilder()
    for (element in this) {
        val valueChar = (element.code - 9999).toChar()
        value.append(valueChar)
    }
    return value.toString()
}

fun ByteArray?.orEmpty(): ByteArray {
    return this?.let {
        return  this
    }?: run {
        return byteArrayOf()
    }
}

val mapping = MAPPING.value()
val reverseMapping = mapping.mapIndexed { index, c -> c to index.toString() }.toMap()

fun String.toU(): String {
    val mapped = this.map { mapping[it - '0'] }.joinToString("")
    return mapped.reversed()
}

fun String.toM(): String {
    val reversed = this.reversed()
    return reversed.map { reverseMapping[it] }.joinToString("")
}

fun Int.toU(): String {
    val value = this.toString().padStart(10, '0')
    val mapped = value.map { mapping[it - '0'] }.joinToString("")
    return mapped.reversed()
}

fun String.fromU(): Int? {
    val reversed = this.reversed()
    val unmapped = reversed.map { mapping.indexOf(it) }.joinToString("")
    return unmapped.toIntOrNull()
}

fun String.getAlphanumeric(): String {
    val hash = simpleHash(this)
    val alphanumeric = hash.joinToString("") { it.toUByte().toString(36) }
    return alphanumeric.take(10).padEnd(10, 'X')
}

private fun simpleHash(input: String): ByteArray {
    val seed = 0x9E3779B9.toUInt()
    return input.fold(seed) { hash, char ->
        hash xor char.code.toUInt()
    }.toString().encodeToByteArray()
}

var appVersion = "1.0.25"
var isDebug = false